import { useCommonStore } from 'state/store/common/useCommonStore';
import { useSearchParams } from 'react-router-dom';
import { useConfigStore } from 'state/store/config/useConfigStore';
import { BlocksLoginPage } from 'components/blocks-login-page';
import { buildOidcAuthorizeUrl, getOidcRuntimeEnv } from 'lib/runtime-env';
import { useMobileDeepLink } from 'hooks/use-mobile-deep-link';
import { MobileDeepLinkLoader } from 'components/core/mobile-deep-link-loader';
import { useEffect, useState } from 'react';
import { KlaxWelcome } from 'components/blocks/klax-welcome';
import { useAuthStore } from 'state/store/auth/useAuthStore';

export function SigninPage() {
  const [searchParams] = useSearchParams();
  const reason = searchParams.get('reason');
  const setUser = useCommonStore((state) => state.setUser);
  const { configurationSettings } = useConfigStore();
  const [isRedirecting, setIsRedirecting] = useState(false);

  setUser(null);

  // Browser Back from OIDC can restore this page via bfcache with isRedirecting still true.
  useEffect(() => {
    const onPageShow = () => setIsRedirecting(false);
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, []);

  const startLogin = async () => {
    if (!configurationSettings) {
      return;
    }

    const oidcEnv = getOidcRuntimeEnv(configurationSettings.paths.baseUrl);
    if (!oidcEnv.initiateUrl || !oidcEnv.clientId || !oidcEnv.redirectUri) {
      return;
    }

    setIsRedirecting(true);
    useAuthStore.getState().setIsOIDCLogin(true);

    const initiateUrl = buildOidcAuthorizeUrl({
      initiateUrl: oidcEnv.initiateUrl,
      clientId: oidcEnv.clientId,
      redirectUri: oidcEnv.redirectUri,
      blocksKey: configurationSettings.blocksKey,
    });

    console.log('[OIDC] Initiate URL:', initiateUrl);
    try {
      const headers: Record<string, string> = {};
      if (configurationSettings.blocksKey) {
        headers['X-Blocks-Key'] = configurationSettings.blocksKey;
      }

      const response = await fetch(initiateUrl, { headers });
      const data = await response.json().catch(() => ({}));

      if (response.ok && data.redirect_uri) {
        window.location.href = data.redirect_uri;
        return;
      }

      console.error('Login initiation failed:', data);
      setIsRedirecting(false);
    } catch (error) {
      console.error('Login initiation error:', error);
      setIsRedirecting(false);
    }
  };

  return (
    <BlocksLoginPage
      buttonLabel={getOidcRuntimeEnv(configurationSettings?.paths.baseUrl).buttonLabel}
      isLoading={isRedirecting}
      reason={reason}
      onLogin={startLogin}
    />
  );
}

